define.alias("checkout/components/seamless-checkout/plan-info-modal", "calendar/components/seamless-checkout/plan-info-modal");